import Config from "../../js/global/Config"

class ingredientsCalculatorComponent {
	constructor() {
		// eslint-disable-next-line no-console
		console.log("ingredientsCalculatorComponent::initialize()")

		this.fractions = {
			"25": "¼",
			"33": "⅓",
			"5": "½",
			"66": "⅔",
			"75": "¾",
		}

		this._component = document.querySelector(".bb-ingredients-calculator")
		this._contentTemplate = this._component.querySelector("template#template-calculator")
		this._perStepTemplate = this._component.querySelector("template#template-per-step")
		this._contentBlockContainer = this._component.querySelector(".bb-ingredients-calculator__content__placeholder")
		this._contentBlock = this._component.querySelector(".bb-ingredients-calculator__content")
		this._portionsAmount = this._component.querySelector(".bb-ingredients-calculator__counter__label b")
		this._recalcFirstColumnWidth(this._contentBlock)

		this.currentPortions = parseInt(this._component.dataset.defaultPortions, 10)
		this.portionStep = parseInt(this._component.dataset.portionStep, 10)
		this.ajaxUrl =
			(Config.debug && Config.proxy ? Config.proxy : "") +
			this._component.dataset.ajaxUrl +
			"?action=" +
			this._component.dataset.ajaxAction +
			"&recipeUid=" +
			this._component.dataset.ajaxRecipeuid +
			"&portions="

		if(typeof this._component.dataset.ajaxPreview !== 'undefined' && this._component.dataset.ajaxPreview) {
			this.ajaxUrl =
				(Config.debug && Config.proxy ? Config.proxy : "") +
				this._component.dataset.ajaxUrl +
				"?action=" +
				this._component.dataset.ajaxAction +
				"&preview=" +
				this._component.dataset.ajaxPreview +
				"&recipeUid=" +
				this._component.dataset.ajaxRecipeuid +
				"&portions="
		}

		this._plusButton = this._component.querySelector(".bb-ingredients-calculator__counter__plus")
		this._minusButton = this._component.querySelector(".bb-ingredients-calculator__counter__minus")
		this._copyButton = this._component.querySelector(".bb-ingredients-calculator__copy-button")

		this.copyButtonText = this._copyButton.innerText
		this.copiedButtonText = this._copyButton.dataset.copiedtext
		this.pdfURL = document.querySelector(".bb-recipe-detail__pdf-button")?.href

		this.copied = false

		this._initEvents()
	}

	_initEvents() {
		this.timerIDsArray = []

		if (this._plusButton) {
			this._plusButton.addEventListener("click", () => {
				this.currentPortions += this.portionStep
				this._rerenderContent()
			})
		}

		if (this._minusButton) {
			this._minusButton.addEventListener("click", () => {
				if (this.currentPortions - this.portionStep < 1) return

				this.currentPortions -= this.portionStep
				this._rerenderContent()
			})
		}

		this._copyButton.addEventListener("click", () => {
			if (this.copied) return

			this._changeCopyState(true)
			let copyText = ""
			for (let item of this._contentBlock.children) {
				let text = "\n" + item.innerText
				if (item.classList.contains("bb-ingredients-calculator__ingredient")) {
					text = text.replaceAll("\n", " ")
				}
				copyText += text + "\n"
			}
			navigator.clipboard.writeText(copyText).then(() => {})
		})
	}

	_rerenderContent() {
		this.timerIDsArray.forEach((id) => {
			clearTimeout(id)
		})

		this._portionsAmount.innerText = this.currentPortions

		this._contentBlockContainer.classList.add("blurred")

		let timerId = setTimeout(() => {
			this._getNewData().then((data) => {
				this._changeCopyState(false)
				this._replaceIngredients(data)
				this._replaceProStep(data)
				if (this.pdfURL) this._updatePDFLink()
			})
		}, 500)
		this.timerIDsArray.push(timerId)
	}

	async _getNewData() {
		let url = this.ajaxUrl + this.currentPortions
		const response = await fetch(url)
		return response.json()
	}

	_replaceProStep(data) {
		document
			.querySelectorAll(".preparation__step__ingredients, .bb-cookmode__preparation__step__ingredients")
			.forEach((element) => {
				let stepid = element.dataset.step - 1

				let tempElement = document.createElement("div")
				tempElement.classList.add("preparation__step__ingredients")
				tempElement.classList.add("mt-16")
				tempElement.classList.add("mb-32")
				tempElement.dataset.step = element.dataset.step

				data.stepIngredients[stepid].forEach((item, i, array) => {
					const template = this._perStepTemplate.cloneNode(true)
					const newContentBlock = template.content

					if (item.product) {
						let parent = newContentBlock.querySelector(".link")
						parent.href = item.product.link
						parent.querySelector(".label").innerText = item.product.name
					} else {
						let parent = newContentBlock.querySelector(".text")
						parent.querySelector(".label").innerText = item.name
					}

				if (parseFloat(item.amount.replace(",", ".")) !== 0) {
					const decimalNumber = item.amount.replace(",", ".")
					let dec = decimalNumber.split(".")[1]
					if (["25", "33", "5", "66", "75"].includes(dec)) {
						const fix = decimalNumber.split(".")[0] !== "0" ? decimalNumber.split(".")[0] : ""
						newContentBlock.querySelector(".amount").innerText = fix + " " + this.fractions[dec] + " " + item.unit + " "
					} else {
						newContentBlock.querySelector(".amount").innerText = item.amount + " " + item.unit + " "
					}
				}
				if (i === array.length - 1) newContentBlock.querySelector(".separator").innerText = ""
				tempElement.appendChild(newContentBlock)
			})
			element.replaceWith(tempElement)
		})
	}

	_replaceIngredients(data) {
		let tempElement = document.createElement("div")
		tempElement.classList.add("bb-ingredients-calculator__content")

		data.ingredients.forEach((item) => {
			const template = this._contentTemplate.cloneNode(true)
			const newContentBlock = template.content

			const subtitle = newContentBlock.querySelector(".bb-ingredients-calculator__ingredient__subtitle")
			const label = newContentBlock.querySelector(".bb-ingredients-calculator__ingredient__label")
			const amount = newContentBlock.querySelector(".bb-ingredients-calculator__ingredient__amount")

			if (item.subtitle && item.subtitle !== " ") {
				subtitle.innerHTML = item.subtitle
			} else {
				subtitle.remove()
			}
			if (item.product) {
				label.innerHTML = '<a href="' + item.product.link + '">' + item.product.name + "</a>"
			} else {
				label.innerText = item.name
			}
			if (parseFloat(item.amount.replace(",", ".")) !== 0) {
				const decimalNumber = item.amount.replace(",", ".")
				let dec = decimalNumber.split(".")[1]
				if (["25", "33", "5", "66", "75"].includes(dec)) {
					const fix = decimalNumber.split(".")[0] !== "0" ? decimalNumber.split(".")[0] : ""
					amount.innerText = fix + " " + this.fractions[dec] + " " + item.unit
				} else {
					amount.innerText = item.amount + " " + item.unit
				}
			} else {
				amount.innerText = ""
			}

			tempElement.appendChild(newContentBlock)
		})

		this._contentBlock = tempElement
		this._contentBlockContainer.prepend(tempElement)
		this._contentBlockContainer.children[this._contentBlockContainer.children.length - 1].style.opacity = 0
		this._contentBlockContainer.style.height = tempElement.offsetHeight + "px"
		this._recalcFirstColumnWidth(this._contentBlock)

		setTimeout(() => {
			this._contentBlockContainer.children[this._contentBlockContainer.children.length - 1].remove()
			tempElement.classList.add("position-static")
			this._contentBlockContainer.style.height = "auto"
			this._contentBlockContainer.classList.remove("blurred")
		}, 300)
	}

	_changeCopyState(newState) {
		this.copied = newState
		this._copyButton.disabled = !!newState
		this._copyButton.querySelector("span").innerText = newState ? this.copiedButtonText : this.copyButtonText
	}

	_recalcFirstColumnWidth(container) {
		let cellsList = container.querySelectorAll(".bb-ingredients-calculator__ingredient__amount")
		let width = 0
		cellsList.forEach((item) => {
			width = item.clientWidth > width ? item.clientWidth : width
		})
		width += 16
		container.style.setProperty("--firstColWidth", width / 16 + "rem")
	}

	_updatePDFLink() {
		document.querySelector(".bb-recipe-detail__pdf-button").href = this.pdfURL + '?portionForCalculateIngredients=' + this.currentPortions
	}
}

export default ingredientsCalculatorComponent
